import { Component, ChangeDetectionStrategy, Type } from '@angular/core';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
} from '@ngx-formly/core';
import { FormlyFieldSelectProps } from '@ngx-formly/core/select';
import { FormlyFieldProps } from '../form-field/form-field.wrapper';
import { FormControl } from '@angular/forms';
import { debounceTime, map, Observable, of, Subject, switchMap } from 'rxjs';

interface SelectProps extends FormlyFieldProps, FormlyFieldSelectProps {
  appendTo?: any;
  filterable?: boolean;
  optionLabel?: string;
  group?: boolean;
  onFilter?: (event: any) => any;
}

export interface FormlySelectFieldConfig
  extends FormlyFieldConfig<SelectProps> {
  type: 'select' | Type<FormlyFieldSelect>;
}

@Component({
  selector: 'formly-field-primeng-select',
  template: `
    <p-select
      [placeholder]="props.placeholder"
      [options]="(props.options | formlySelectOptions: field | async) ?? []"
      [formControl]="formControl"
      [formlyAttributes]="field"
      styleClass="field-select-panel"
      [showClear]="!props.required"
      [appendTo]="props.appendTo"
      [group]="props.group"
      [filter]="props.filterable"
      [optionLabel]="props.optionLabel"
      (onChange)="props.change && props.change(field, $event)"
    >
    </p-select>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldSelect extends FieldType<FieldTypeConfig<SelectProps>> {
  filterControl = new FormControl('');

  constructor() {
    super();
    // TODO : Finish this maybe its a better solution than the api-select
    this.filterControl.valueChanges
      .pipe(debounceTime(100))
      .subscribe((value) => {
        if (this.props.onFilter) {
          const options = this.props.onFilter(value);
          (this.props.options as any) = options;

          console.log(options);
        }
      });
  }
}
